// @mui
import { SvgIcon } from "@mui/material";

function UserProfileFillIcon(props) {
  return (
    <SvgIcon
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      sx={{
        fill: "transparent",
        "& path": {
          stroke: (theme) => theme.palette.common.white,
        },
      }}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Iconly/Bold/Profile" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Profile" transform="translate(4.000000, 2.000000)" fill="#000000" fillRule="nonzero">
          <path d="M8,13.1739317 C12.338627,13.1739317 16,13.8789388 16,16.598966 C16,19.3199932 12.314618,20 8,20 C3.66237339,20 5.68434189e-14,19.2949929 5.68434189e-14,16.5749657 C5.68434189e-14,13.8539385 3.68538202,13.1739317 8,13.1739317 Z M8,-6.03961325e-14 C10.9391022,-6.03961325e-14 13.2939852,2.35402354 13.2939852,5.29105291 C13.2939852,8.22808228 10.9391022,10.5831058 8,10.5831058 C5.06189821,10.5831058 2.70601476,8.22808228 2.70601476,5.29105291 C2.70601476,2.35402354 5.06189821,-6.03961325e-14 8,-6.03961325e-14 Z"></path>
        </g>
      </g>
    </SvgIcon>
  );
}

export default UserProfileFillIcon;
